import React, { useEffect } from "react";
import styles from "./Profile.module.css";
import { useState } from "react";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Navigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { getTokenInfo } from "../../../utils/Guard";
import { Password } from "primereact/password";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../../store/ui-slice";
import { userActions } from "../../../store/auth-store/auth-slice";
import {
  GetUserById,
  RegisterUser,
  UpdateDetail,
  UpdatePassword,
} from "../../../store/auth-store/auth-actions";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import { GetDepartments } from "../../../store/department-store/department-actions";
import { countriesArray } from "../../../components/List";
import { GetCompanies } from "../../../store/company-store/company-actions";
import { InputMask } from "primereact/inputmask";
import Loading from "../../../components/loading/Loading";

const Profile = () => {
  const userInfo = getTokenInfo();
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();

  const [selectedCountry, setSelectedCountry] = useState();
  const [inputValue, setInputValue] = useState("");
  const [selectedCharge, setSelectedCharge] = useState({ code: 0, name: "" });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState({
    code: 0,
    name: "",
  });
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [charges, setCharges] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const company = useSelector((state) => state.company);
  const charge = useSelector((state) => state.charge);
  const department = useSelector((state) => state.department);
  const country = countriesArray;
  const user = useSelector((state) => state.auth.auth);
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, null, false));
      setTimeout(function () {
        setIsLoading(false);
      }, 1500);
    }
  });

  useEffect(() => {
    if (company.companies === undefined || company.companies.length === 0) {
      dispatch(GetCompanies("capacitaciones@aba.org.do"));
    }
  });

  useEffect(() => {
    if (charge.charges === undefined || charge.charges.length === 0) {
      dispatch(GetCharges("capacitaciones@aba.org.do", true));
    }
  });

  useEffect(() => {
    if (
      department.departments === undefined ||
      department.departments.length === 0
    ) {
      dispatch(GetDepartments("capacitaciones@aba.org.do", true));
    }
  }, [department.departments, dispatch]);

  useEffect(() => {
    if (charge.charges !== undefined && charge.charges.length > 0) {
      const listCharges = charge.charges.map((charge) => {
        return {
          code: charge.id,
          name: charge.name,
        };
      });
      setCharges(listCharges);
    }
  }, [charge.charges]);

  useEffect(() => {
    if (company.companies !== undefined && company.companies.length > 0) {
      const listCompanies = company.companies.map((company) => {
        return {
          code: company.id,
          name: company.name,
          rnc: company.rnc,
        };
      });
      setCompanies(listCompanies);
    }
  }, [company.companies]);

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);

  useEffect(() => {
    if (
      department.departments !== undefined &&
      department.departments.length > 0
    ) {
      const listDepartments = department.departments.map((department) => {
        return {
          code: department.id,
          name: department.name,
        };
      });
      setDepartments(listDepartments);
    }
  }, [department.departments]);

  useEffect(() => {
    if (
      userInfo !== null &&
      userInfo !== undefined &&
      userInfo.UserId !== undefined &&
      userInfo.UserId !== null
    ) {
      if (selectedCountry === undefined || selectedCountry === null) {
        const foundCountry = country.find(
          (country) => country.name === user.country
        );

        if (foundCountry !== undefined && foundCountry !== null) {
          const countryWithCode = {
            ...foundCountry,
            code: foundCountry.name,
            flag: foundCountry.abreviatura,
          };
          delete countryWithCode.abreviatura;
          onChangeCountriesHandler("countryid", countryWithCode);
        }
      }
      if (
        selectedDepartment.code === 0 &&
        user.department.id !== 0 &&
        user.department.id !== null &&
        user.department.id !== undefined
      ) {
        const departmentWithCode = {
          ...user.department,
          code: user.department.id,
        };
        delete departmentWithCode.id;
        onChangeDepartmentHandler("department", departmentWithCode);
      }

      if (
        selectedCharge.code === 0 &&
        user.charge.id !== 0 &&
        user.charge.id !== null &&
        user.charge.id !== undefined
      ) {
        const chargeWithCode = {
          ...user.charge,
          code: user.charge.id,
        };
        delete chargeWithCode.id;
        onChangeChargesHandler("charge", chargeWithCode);
      }
      if (
        selectedCompany === undefined || selectedCompany === null &&
        user.company.id !== 0 &&
        user.company.id !== null &&
        user.company.id !== undefined
      ) {
        onChangeCompaniesHandler("company", user.company.name);
      }
      
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      notification !== undefined &&
      notification !== null &&
      notification !== "" &&
      notification.message === "Contraseña actualizada correctamente."
    ) {
      window.location.href = "/";
    }
  }, [notification]);

  useEffect(() => {
    if (
      userInfo === undefined ||
      userInfo === null ||
      userInfo.UserId === undefined ||
      userInfo.UserId === null ||
      userInfo.UserId === ""
    ) {
      window.location.href = "/";
    }
  }, [userInfo]);

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const onChangeCompaniesHandler = (id, value) => {
    dispatch(
      userActions.modifyPropertyValue({
        id,
        value: {
          id: 0,
          name: value,
        },
      })
    );
    
    setSelectedCompany(value);
  };

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCharge({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeDepartmentHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedDepartment({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };

  const submitChangePassword = async (event) => {
    dispatch(UpdatePassword(user));
    if (uiActions.iswarning) {
    }
  };
  const onSubmitHandler = async (event) => {
    var compa = {};
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany.code !== undefined
    ) {
      compa = { ...selectedCompany };
    } else {
      compa = {
        code: 0,
        name: selectedCompany,
      };
    }

    const newUser = {
      ...user,
      charge: {
        id: selectedCharge.code,
        name: selectedCharge.name,
      },
      department: {
        id: selectedDepartment.code,
        name: selectedDepartment.name,
      },
      country: selectedCountry.name,
      company: compa,
    };

    dispatch(UpdateDetail(user.email, newUser));
    setEditMode(false);
  };

  if (isLoading) {
    return <Loading />;
  }


  return (
    <div>
      {userInfo !== null && userInfo.UserId !== undefined && (
        <div className={styles.profile}>
          <div className={styles.header}>
            <div className={styles.profileInfo}>
              <Button
                className={styles.profileIcon}
                icon="pi pi-user"
                rounded
                outlined
                severity="info"
                aria-label="User"
                onClick={() => Navigate("/profile")}
              />
              <div className={styles.infoContainer}>
                <h1 className={styles.profileName}>{userInfo.FullName}</h1>
                <h2 className={styles.profileEmail}>{userInfo.Email}</h2>
              </div>
            </div>
            {editMode ? (
              <Button
                className={styles.editButton}
                label="Guardar"
                icon="pi pi-check"
                onClick={() => setEditMode(false)}
              />
            ) : (
              <Button
                className={styles.editButton}
                label="Editar"
                icon="pi pi-pencil"
                onClick={() => setEditMode(true)}
              />
            )}
          </div>
          <div className={styles.profileForm}>
            <form className={styles.forms}>
              <div className={styles.column}>
                <label htmlFor="nombre">Nombre</label>
                <InputText
                  disabled
                  defaultValue={userInfo.Name}
                  type="text"
                  id="name"
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="apellido">Apellido</label>
                <InputText
                  disabled
                  defaultValue={userInfo.LastName}
                  type="text"
                  id="lastName"
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="telefono">Teléfono</label>
                <InputMask
                  id="cellPhone"
                  value={user.cellPhone}
                  defaultValue={user.cellPhone}
                  onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                  mask="+1999-999-9999"
                  disabled={!editMode}
                  // placeholder="+1999-999-9999"
                  style={{
                    width: !isMobile ? "100%" : "70%",
                    marginRight: "3%",
                  }}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="pais">País</label>
                <Dropdown
                  value={selectedCountry}
                  onChange={(e) => {
                    onChangeCountriesHandler("countryid", e.value);
                  }}
                  options={countries}
                  optionLabel="name"
                  placeholder="Seleccionar pais"
                  valueTemplate={selectedCountryTemplate}
                  filter
                  itemTemplate={countryOptionTemplate}
                  className={styles.profileDropdown}
                  disabled={!editMode}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="ciudad">Ciudad</label>
                <InputText
                  defaultValue={user.city}
                  onChange={(e) => onChangeHandler("city", e.target.value)}
                  value={user.city}
                  type="text"
                  id="city"
                  disabled={!editMode}
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="direccion">Dirección</label>
                <InputText
                  onChange={(e) => onChangeHandler("address", e.target.value)}
                  value={user.address}
                  defaultValue={user.address}
                  type="text"
                  id="address"
                  disabled={!editMode}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="empresa">Empresa</label>
                <Dropdown
                  className={styles.companyInput}
                  onChange={(e) => onChangeCompaniesHandler("company", e.value)}
                  options={companies}
                  optionLabel="name"
                  editable
                  filter
                  placeholder="Seleccionar empresa"
                  value={selectedCompany}
                  // type="text"
                  id="company"
                  disabled={!editMode}
                />
              </div>

              {/* <div className={styles.column}>
                <label htmlFor="departamento">Departamento</label>
                <Dropdown
                  onChange={(e) =>
                    onChangeDepartmentHandler("department", e.value)
                  }
                  optionLabel="name"
                  value={selectedDepartment}
                  options={departments}
                  className={styles.profileDropdown}
                  placeholder="Seleccionar departamento"
                  defaultValue={""}
                  filter
                  id="department"
                  disabled={!editMode}
                />
              </div> */}
              <div className={styles.column}>
                <label htmlFor="cargo">Cargo</label>
                <Dropdown
                  onChange={(e) => onChangeChargesHandler("charge", e.value)}
                  value={selectedCharge}
                  options={charges}
                  optionLabel="name"
                  className={styles.profileDropdown}
                  defaultValue={userInfo.charge}
                  placeholder="Seleccionar cargo"
                  filter
                  // type="text"
                  id="charge"
                  disabled={!editMode}
                />
              </div>
            </form>
            {editMode ? (
              <Button
                className={styles.saveButton}
                label="Guardar"
                onClick={() => onSubmitHandler()}
              />
            ) : null}
          </div>
          <div>
            <label className={styles.profileName}>Cambiar contraseña</label>
            <form className={styles.changePasswordForms}>
              <div className={styles.column}>
                <label htmlFor="Nueva contraseña">Contraseña actual</label>
                <Password
                  className={styles.passwordInput}
                  onChange={(e) => onChangeHandler("password", e.target.value)}
                  value={user.password}
                  type="text"
                  id="password"
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="contraseña">Nueva contraseña</label>
                <Password
                  className={styles.passwordInput}
                  value={user.newPassword}
                  onChange={(e) =>
                    onChangeHandler("newPassword", e.target.value)
                  }
                  type="text"
                  id="newPassword"
                />
              </div>
            </form>
            <Button
              className={styles.saveButton}
              label="Cambiar contraseña"
              onClick={() => submitChangePassword()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
